import * as angular from 'angular';

import { ComponentDefinition, IShewhartWidgetConfiguration, SelectorType } from '../../../models/index';

class CalculatedShewhartStateController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;

    configuration: IShewhartWidgetConfiguration;
    static $inject = ['$stateParams'];

    constructor(private $stateParams: angular.ui.IStateParamsService) {
    }

    $onInit() {
        this.configuration = {
            guid: this.$stateParams['identifierGuid'],
            selectorType: SelectorType.identifier
        };
    }
}

export const wtCalculatedShewhartState: ComponentDefinition = {
    componentId: 'wtCalculatedShewhartState',
    controller: CalculatedShewhartStateController,
    template: require('./calculatedShewhartState.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};
